import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { createContext, useState } from 'react';
export var EmojiPickerListContext = /*#__PURE__*/createContext({
  currentEmojisFocus: {
    rowIndex: 0,
    columnIndex: 0
  },
  setEmojisFocus: function setEmojisFocus() {}
});
export var EmojiPickerListContextProvider = function EmojiPickerListContextProvider(props) {
  var _useState = useState(props.initialEmojisFocus),
    _useState2 = _slicedToArray(_useState, 2),
    currentEmojisFocus = _useState2[0],
    setEmojisFocus = _useState2[1];
  return /*#__PURE__*/React.createElement(EmojiPickerListContext.Provider, {
    value: {
      currentEmojisFocus: currentEmojisFocus,
      setEmojisFocus: setEmojisFocus
    }
  }, props.children);
};